// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import AnimationsController from "classes/Animations/AnimtionsController";
import PageHeadBar from "components/HeadBar/PageHeadBar";
import PreviewDrawer from "components/PreviewDrawer/PreviewDrawer";
import useUnread from "classes/Accounts/hooks/useUnread";
import genRequest from "includes/request";
import AnimationObject from "classes/Animations/AnimationObject";
import useAccount from "classes/Accounts/hooks/useAccount";
import { t } from "i18next";
import formatDate, { dateAdd } from "includes/formatDate";
import useEditing from "components/EditDrawer/useEditing";
import promiseToast from "components/Toasts/PromiseToast";
import useSelect from "hooks/useSelect";
import EventsList from "./components/EventsList/EventsList";
import AnimationEditDrawer from "./components/AnimationEditDrawer/AnimationEditDrawer";
import AnimationsDraftsTable from "./components/AnimationsDraftsTable";
import Calendar from "./components/Calendar/Calendar";
import AnimationPreview from "./components/AnimationPreview/AnimationPreview";
import useTemplate from "hooks/useTemplate";
import { usePostContext } from "providers/PostProvider";

export default function AnimationsPage(props) {
	return (
		<>
			<AnimationsController
				childComponent={AnimsPageBody}
				childprops={props}
				events={props.animations}
			/>
		</>
	);
}

function AnimsPageBody(props) {
	const QCL = useQueryClient();
	const { account, isAdmin } = useAccount();
	const { getAppFunction } = useTemplate();
	const { setAsReaded } = useUnread();
	const [curDay, setCurday] = useState(false);
	const [curEvent, setCurEvent] = useState(false);
	const [editObj, setEditObj] = useState(false);
	const [ShowDrafts, setShowDrafts] = useState(false);
	const { editing, setEditing } = useEditing();
	const { isMenuOpen, setIsMenuOpen } = props;
	const { confirmDelete } = useSelect();
	const { postToCreate, setPostToCreate } = usePostContext();

	function handleEventClick(event) {
		setCurEvent(event);
		incrementViews(event).then(() => {
			setAsReaded("NotViewedEvent", event.id);
			QCL.invalidateQueries(["NotViewed", "Me", "NotViewedEvent"]);
		});
	}

	function handleDraftClick(event) {
		setCurEvent({ ...event, id: event.animationId });
	}

	const incrementViews = (event) => {
		if (!event?.id) return Promise.resolve(null);
		return genRequest(
			`animations/${event.id}/increment-view`,
			null,
			"put"
		);
	};

	useEffect(() => {
		if (postToCreate) {
			// handleAddingNewPost(postToCreate);
			setCurEvent(false);
			setEditObj(postToCreate);
			setEditing(true);
			// postToCreate.fetchForEdit().then(() => {
			// });
		}
	}, [postToCreate]);

	function handleDateClick(arg, events) {
		setCurday({
			events: events,
			date: arg.date,
		});
		setCurEvent(false);
	}

	function handleClosePreview() {
		setCurEvent(false);
	}

	function handleAdd(initAnimObj) {
		setCurEvent(false);
		// Callers (calendar click, range select, context menu) pass dateStart
		// / dateEnd as a Date, a timestamp or a formatted string: normalize
		// them after the spread so they always reach the object formatted.
		let date = formatDate(initAnimObj?.dateStart || new Date());
		let end = initAnimObj?.dateEnd
			? formatDate(initAnimObj.dateEnd)
			: dateAdd(date, { hours: 1 });
		let obj = new AnimationObject({
			companyId: account.companyId,
			author: account,
			linkType: "sites",
			displayParticipation: getAppFunction(
				"AnimationsPage.CanParticipate"
			),
			...initAnimObj,
			dateStart: date,
			dateEnd: end,
		});
		setEditObj(obj);
		setEditing(true);
	}

	function handleModify(item) {
		let anim = item;
		if (item.extendedProps) anim = item.extendedProps;
		// The editor stands in for an author the event does not record
		let obj = new AnimationObject({
			...anim,
			author: account,
			isDraft: false,
		});
		let prom = obj.fetchForEdit().then(() => {
			setEditObj(obj);
			setEditing(true);
		});
		return prom;
	}

	function handleDelete(item) {
		let title = `${t("Events.THE_EVENT")} "${item.title}" ${t(
			"Events.WILL_BE_DELETE"
		)}`;
		confirmDelete(
			() => {
				deleteEvent(item);
			},
			null,
			title
		);
	}

	function deleteEvent(item) {
		if (!isAdmin()) return false;
		let animationId = item.extendedProps?.animationId || item.id;
		let req = genRequest(
			`animations/${animationId}`,
			null,
			"delete",
			{
				reportOnFail: true,
			}
		).then(() => {
			QCL.refetchQueries(["Animations"]);
			if (item.remove) item.remove();
			setCurEvent(false);
		});
		promiseToast(req, {
			pending: t("Events.DELETING"),
		});
		return req;
	}

	function handleClone(item) {
		if (!isAdmin()) return false;
		let anim = item;
		if (item.extendedProps) anim = item.extendedProps;
		// The editor stands in for an author the event does not record
		let obj = new AnimationObject({
			...anim,
			author: account,
			isDraft: false,
		});
		let prom = obj.fetchForClone().then(() => {
			obj.animationId(false);
			obj.isCloned = true;
			let post = obj.linkedPost();
			if (post) obj.linkedPost().postId(false);
			setEditObj(obj);
			setEditing(true);
		});
		return prom;
	}

	function handleCloseEdit() {
		setEditing(false);
		setEditObj(false);
		setPostToCreate(null);
		QCL.resetQueries(["Animations"]);
	}

	function filterEvents() {
		if (!props?.events?.length) return [];
		let ret = props.events.filter((a) => {
			let item = { ...a };
			if (item.dateStart === item.dateEnd)
				item.dateEnd = formatDate(
					dateAdd(item.dateStart, { minutes: 1 })
				);
			if ((!ShowDrafts && !item.isDraft) || (ShowDrafts && item.isDraft))
				return item;
			return false;
		});
		return ret;
	}

	return (
		<div className="AnimationsPage position-relative d-flex flex-column h-100">
			{!editObj ? (
				<>
					<PageHeadBar
						typeId={8}
						siteSelect={false}
						search={false}
						handleAdd={handleAdd}
						addTitle={t("Events.ADD_TITLE")}
						title={props.title}
						setIsMenuOpen={setIsMenuOpen}
						isMenuOpen={isMenuOpen}
						categories={false}
						headButtons={[
							{
								title: t("Commons.DRAFTS"),
								classes: ShowDrafts ? "btn-primary" : "",
								enabled: props.isAdmin,
								onClick: () => setShowDrafts(!ShowDrafts),
							},
						]}
					/>
					{!ShowDrafts ? (
						<div className="overflow-auto h-100 d-flex flex-column">
							<Calendar
								handleDateClick={handleDateClick}
								handleEventClick={handleEventClick}
								handleAdd={handleAdd}
								handleClone={handleClone}
								handleDelete={handleDelete}
								handleModify={handleModify}
								events={filterEvents()}
							/>
							{curDay && (
								<EventsList
									{...curDay}
									onItemClick={handleEventClick}
								/>
							)}
						</div>
					) : (
						<AnimationsDraftsTable
							events={filterEvents()}
							onItemClick={handleDraftClick}
						/>
					)}
					{curEvent && (
						<PreviewDrawer
							slideRight={true}
							key={curEvent.id}
							isOpen={true}
							onClose={handleClosePreview}
							child={AnimationPreview}
							childProps={{
								event: curEvent,
								responsive: false,
								handleModify,
								handleClone,
								handleDelete,
							}}
							backBtnText={t("Commons.CLOSE")}
						/>
					)}
				</>
			) : (
				<>
					{editObj && (
						<AnimationEditDrawer
							typeId={8}
							onClose={handleCloseEdit}
							animation={editObj}
							isOpen={editing && editObj}
							account={account}
							initQueries={[
								{
									queryKey: [
										"AnimationEdit",
										"FetchForEdit",
										Date.now(),
									],
									queryFn: () => editObj.fetchForEdit(),
									retry: 0,
									suspense: true,
									enabled:
										editObj.isCloned ||
											!editObj.animationId()
											? false
											: true,
								},
							]}
						/>
					)}
				</>
			)}
		</div>
	);
}
